import React from 'react';

import { Desktop, Mobile } from '../Common/const';

function padLeft(nr, n, str) {
  const size = Math.max(0, n - String(nr).length + 1);
  return Array(size).join(str || '0') + nr;
}

class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.secToMin(this.props.time),
    };
  }

  secToMin = (seg) => {
    if (seg) {
      const min = Math.floor(seg / 60);
      const sec = seg - min * 60;
      return `${padLeft(min, 2)}:${padLeft(sec, 2)}`;
    }
    return '-';
  };

  exitQuiz = () => {
    this.props.exitQuiz();
  };

  render() {
    if (this.props.review) {
      return (
        <button
          className="btn btn-danger exit-exam-btn"
          onClick={this.exitQuiz}
        >
          EXIT REVIEW
        </button>
      );
    }
    return (
      <div className="timer">
        <Desktop>
          <div className="timer-top d-flex flex-row">
            <p>
              <i className="icon icon-clock" /> {this.secToMin(this.props.time)}
            </p>
          </div>
          <div className="timer-bottom" onClick={this.exitQuiz}>
            EXIT QUIZ
          </div>
        </Desktop>
        <Mobile>
          <div className="timer-left">
            <p>
              <i className="icon icon-clock" /> {this.secToMin(this.props.time)}
            </p>
          </div>
          <div className="timer-right" onClick={this.exitQuiz}>
            EXIT QUIZ
          </div>
        </Mobile>
      </div>
    );
  }
}

export default Timer;
